<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12 d-flex flex-wrap justify-content-between">
            <!-- <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                routerLink="/user/create-user"><i class="fas fa-user-plus">
                </i>Create Users</button> -->
        </div>

        <div class="col-12">

            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3">{{ "INQUIRY_TITLE" | translate | titlecase }} <button
                        class="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                        aria-controls="collapseOne" *ngIf="showLoader==false">
                        <!-- {{"ADVANCED_SEARCH" | translate | titlecase }} -->
                        <i class="fas fa-filter"></i>
                    </button></h5>

                <app-loader [show]="showLoader"></app-loader>
                <br>
                <div id="accordion" style="margin-left: 10%; margin-right: 10%;" *ngIf="showLoader==false">
                    <div class="card">
                        <!-- <div class="card-header" id="headingOne" style="padding: 3px;">
                            <h5 class="mb-0"
                                style="text-align: center;font-weight:bold;text-align: center;font-weight: bold;">
                                <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne"
                                    aria-expanded="true" aria-controls="collapseOne" style="width: 100%;">
                                    {{"ADVANCED_SEARCH" | translate | titlecase }}
                                    <i class="fas fa-filter"></i>
                                </button>
                            </h5>
                        </div> -->

                        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                            <div class="card-body">
                                <form [formGroup]="filterVaild" (change)="filterChange()" (submit)="filterSubmit()">
                                    <div class="row">
                                        <div class="col-md-4 form-group px-md-5 mb-4">
                                            <label class="font-bold">{{ "START_DATE" | translate | titlecase }}</label>
                                            <input type="date" class="form-control" formControlName="evalStartDate">
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="filterVaild.controls.evalStartDate.touched && filterVaild.controls.evalStartDate.invalid && filterVaild.dirty">
                                                {{ "PLEASE_SELECT_AVAILED_DATE" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-4 form-group px-md-5 mb-4">
                                            <label class="font-bold">{{ "END_DATE" | translate | titlecase }}</label>
                                            <input type="date" class="form-control" formControlName="evalEndDate">
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="filterVaild.controls.evalEndDate.touched && filterVaild.controls.evalEndDate.invalid && filterVaild.dirty">
                                                {{ "PLEASE_SELECT_AVAILED_DATE" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-4 form-group px-md-5 mb-4" style="margin: auto;">

                                            <button type="submit" class="btn btn-primary">
                                                {{ "SEARCH" | translate | titlecase }}</button>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- server search  -->
                <!-- <form [formGroup]="filterVaild" (change)="filterChange()" (submit)="filterSubmit()">
                    <div class="row" >
                        <div class="col-md-4 form-group px-md-5 mb-4">
                            <label class="font-bold">{{ "START_DATE" | translate | titlecase }}</label>
                            <input type="date" class="form-control" formControlName="evalStartDate">
                            <div class="alert alert-danger py-1 mt-1"
                                *ngIf="filterVaild.controls.evalStartDate.touched && filterVaild.controls.evalStartDate.invalid && filterVaild.dirty">
                                {{ "PLEASE_SELECT_AVAILED_DATE" | translate | titlecase }}
                            </div>
                        </div>
                        <div class="col-md-4 form-group px-md-5 mb-4">
                            <label class="font-bold">{{ "END_DATE" | translate | titlecase }}</label>
                            <input type="date" class="form-control" formControlName="evalEndDate">
                            <div class="alert alert-danger py-1 mt-1"
                                *ngIf="filterVaild.controls.evalEndDate.touched && filterVaild.controls.evalEndDate.invalid && filterVaild.dirty">
                                {{ "PLEASE_SELECT_AVAILED_DATE" | translate | titlecase }}
                            </div>
                        </div>
                        <div class="col-md-4 form-group px-md-5 mb-4">
                           
                                <button type="submit" class="btn btn-primary" >
                                    {{ "NEXT" | translate | titlecase }}</button>
                        </div>
                    </div>

                </form> -->
                <!--
                <app-loader [show]="searching"></app-loader> -->

                <div class="table-responsive py-3" style="padding: 1rem!important" *ngIf="showLoader==false">
                    <!-- <button (click)="downloadPDF()" class="btn-search-table">
                        <i class="fas fa-search"></i>export pdf
                    </button> -->
                    <div class="row">
                        <div class="col-sm-1">
                            <button (click)="generateExcel()" class="btn" style="height:auto"><span
                                    style="font-size: 2em; color: green;"><i
                                        class="fas fa-file-excel fa-sm"></i></span></button>
                        </div>
                        <div class="col-md-6" style="margin: auto 0">
                            <ng-multiselect-dropdown placeholder="{{'EXPORT_COLUMNS' | translate | titlecase }}"
                                [settings]="dropdownSettings" [data]="excelExportColumnsOption"
                                [(ngModel)]="exportColumnsSelected" (onSelect)="onItemSelect($event)">
                            </ng-multiselect-dropdown>
                        </div>
                    </div>
                    <br />

                    <table class="table-striped" class="table" id="datatable">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>{{"CANDUDATE_CODE" | translate | titlecase }}</th>
                                <th>{{"CANDIDATE_NAME" | translate | titlecase }}</th>
                                <th>{{"CANDIDATE_PHOTO" | translate | titlecase }}</th>
                                <th>{{"EMAIL" | translate | titlecase }}</th>
                                <th>{{"INVITATION_DATE" | translate | titlecase }}</th>
                                <th>{{"GENDER" | translate | titlecase }}</th>
                                <th>{{"NID" | translate | titlecase }}</th>
                                <th>{{"PROVINCE" | translate | titlecase }}</th>
                                <th>{{"SCORE" | translate | titlecase }}</th>
                                <th>{{"STATUS" | translate | titlecase }}</th>

                                <!-- actions -->

                                <!-- <th class="border-0 font-14 px-2 text-grey">{{"PREVIEW" | translate | titlecase }}</th> -->
                                <th class="border-0 font-14 px-2 text-grey"
                                    *ngIf="globals.checkUserHasPermission('CANDIDATE_INQUIRY - MOODLE')">
                                    {{"MODEL_TEST_RESULT" | translate | titlecase }}</th>
                                <th class="border-0 font-14 px-2 text-grey"
                                    *ngIf="globals.checkUserHasPermission('CANDIDATE_INQUIRY - INTERVIEW')">
                                    {{"PERSONAL_INTERVIEW" | translate | titlecase }}</th>
                                <th class="border-0 font-14 px-2 text-grey"
                                    *ngIf="globals.checkUserHasPermission('CANDIDATE_INQUIRY - MEDICAL')">
                                    {{"MEDICAL_CHECH" | translate | titlecase }}
                                </th>
                                <th class="border-0 font-14 px-2 text-grey"
                                    *ngIf="globals.checkUserHasPermission('CANDIDATE_INQUIRY - EVALUATION')">
                                    {{"EVALUATION" | translate | titlecase }}
                                </th>
                                <!-- *ngIf="globals.checkUserHasPermission('CANDIDATE_INQUIRY - PREVIEW')" -->
                                <th class="border-0 font-14 px-2 text-grey"
                                    *ngIf="globals.checkUserHasPermission('CANDIDATE_INQUIRY - PREVIEW')">{{"PREVIEW" |
                                    translate |
                                    titlecase }}
                                </th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let res of candidateInquiriesData; let i = index">
                                <td class="cursor-pointer">{{res.candid}}</td>
                                <td class="cursor-pointer">{{res.candCode}}</td>
                                <td class="cursor-pointer">{{
                                    (globals.lang == 'ar')? res.fullNameAr : res.fullNameEn
                                    }}</td>
                                <!-- <td class="cursor-pointer">{{res.photoFilename}}</td> -->
                                <td class="cursor-pointer">
                                    <img src="{{photoPath+ res.photoFilename}}"
                                        onerror="this.src ='assets/images/stud-image.png';" alt="Photo"
                                        class="img-fluid" width="70" id="userImageTag" (load)="getBase64($event, i)"
                                        crossOrigin='Anonymous'>
                                </td>
                                <td class="cursor-pointer">{{ res.emailAddress1 }}</td>
                                <td class="cursor-pointer">{{ res.invitationDate | date }}</td>
                                <td class="cursor-pointer">{{ res.gender == "M"? ("MALE" | translate | titlecase) :
                                    ("FEMALE" | translate |
                                    titlecase) }}</td>
                                <td class="cursor-pointer">{{res.nidNo}}</td>
                                <td class="cursor-pointer">{{
                                    (globals.lang == 'ar')? res.addressProvinceAr : res.addressProvinceEn
                                    }}</td>
                                <td class="cursor-pointer">{{res.thanawyaScore}}</td>
                                <td class="cursor-pointer">{{
                                    (globals.lang == 'ar')? res.statusAr : res.statusEn
                                    }}</td>

                                <!-- <td class="text-bold text-warning">
                                    <button class="btn btn-sm btn-link text-warning" (click)="Preview(res?.id)"><i
                                            class="fas fa-window-restore"></i>
                                        {{"PREVIEW" | translate | titlecase }}</button>
                                </td> -->
                                <td class="text-bold text-warning"
                                    *ngIf="globals.checkUserHasPermission('CANDIDATE_INQUIRY - MOODLE')">
                                    <!-- <button class="btn btn-sm btn-link text-warning"
                                        (click)="moodleTestResults(res?.candid)"
                                        *ngIf="checkUserStatusAccept(res.appstatusid)"><i
                                            class="fas fa-window-restore"></i>

                                        {{"MOODLE_TEST_RESULT" | translate | titlecase }}</button> -->
                                    <a routerLink="/admission/english-test" [queryParams]="{candId: res?.candid}"
                                        class="btn btn-sm btn-link text-warning"
                                        *ngIf="checkUserStatusAccept(res.appstatusid)"><i
                                            class="fas fa-window-restore"></i>

                                        {{"MOODLE_TEST_RESULT" | translate | titlecase }}</a>

                                </td>
                                <td class="text-bold text-warning"
                                    *ngIf="globals.checkUserHasPermission('CANDIDATE_INQUIRY - INTERVIEW')">
                                    <a routerLink="/admission/personal-interview" [queryParams]="{candId: res?.candid}"
                                        class="btn btn-sm btn-link text-warning" data-toggle="modal"
                                        data-target="#deleteModal" *ngIf="checkUserStatusAccept(res.appstatusid)"><i
                                            class="fas fa-window-restore"></i>

                                        {{"PERSONAL_INTERVIEW" | translate | titlecase }}

                                    </a>
                                </td>
                                <td class="text-bold text-warning"
                                    *ngIf="globals.checkUserHasPermission('CANDIDATE_INQUIRY - MEDICAL')">
                                    <a routerLink="/admission/medical-check" [queryParams]="{candId: res?.candid}"
                                        class="btn btn-sm btn-link text-warning" data-toggle="modal"
                                        data-target="#deleteModal" *ngIf="checkUserStatusAccept(res.appstatusid)"><i
                                            class="fas fa-window-restore"></i>

                                        {{"MEDICAL_CHECH" | translate | titlecase }}

                                    </a>
                                </td>
                                <td class="text-bold text-warning"
                                    *ngIf="globals.checkUserHasPermission('CANDIDATE_INQUIRY - EVALUATION')">
                                    <a routerLink="/admission/evaluate" [queryParams]="{candId: res?.candid}"
                                        class="btn btn-sm btn-link text-warning" data-toggle="modal"
                                        data-target="#deleteModal" *ngIf="checkUserEvalutionAccept(res.appstatusid)"><i
                                            class="fas fa-window-restore"></i>

                                        {{"EVALUATION" | translate | titlecase }}

                                    </a>
                                </td>
                                <!-- *ngIf="globals.checkUserHasPermission('CANDIDATE_INQUIRY - PREVIEW')" -->
                                <td class="text-bold text-warning"
                                    *ngIf="globals.checkUserHasPermission('CANDIDATE_INQUIRY - PREVIEW')">
                                    <a routerLink="/admission/cand-preview" [queryParams]="{candId: res?.candid}"
                                        class="btn btn-sm btn-link text-warning"><i class="fas fa-window-restore"></i>
                                        {{"PREVIEW" | translate | titlecase }}

                                    </a>
                                </td>
                            </tr>
                        </tbody>

                    </table>

                    <!-- server footer
                    <div class="d-flex justify-content-between flex-wrap p-3">
                        <div>
                            <b>Showing</b> {{currentIndex * pageLength + 1}} - {{usersSearch.length + currentIndex *
                            pageLength}}
                            <b>of</b>
                            {{totalRecords}}
                        </div>
                        <nav aria-label="Page navigation example">
                            <ul class="pagination pagination-sm flex-wrap">
                                <li class="page-item rounded-0">
                                    <a class="page-link border-0" (click)="getNewData(currentIndex - 1)"
                                        [class.disabled]="currentIndex == 0">Previous</a>
                                </li>
                                <li class="page-item rounded-0" [class.active]="currentIndex == i"
                                    *ngFor="let page of paging;let i=index">
                                    <a class="page-link border-0 " (click)="getNewData(i)">{{i+1}}</a>
                                </li>
                                <li class="page-item rounded-0">
                                    <a class="page-link border-0" (click)="getNewData(currentIndex + 1)"
                                        [class.disabled]="currentIndex == paging.length - 1">Next</a>
                                </li>
                            </ul>
                        </nav>
                    </div> -->

                </div>
            </div>
        </div>


    </div>
</div>

<!--Export table-->
<div #pdfPage id="pdfPage" style="width:100%;height:100%;position: absolute;top:0;left:0;z-index:-1;" *ngIf="false">
    <table class="table-bordered" style="width:100%;height:100%;">
        <thead>
            <tr>
                <th>#</th>
                <th>{{"CANDIDATE_NAME" | translate | titlecase }}</th>
                <th>{{"CANDIDATE_PHOTO" | translate | titlecase }}</th>
                <!--                          <th>{{"GENDER" | translate | titlecase }}</th>  -->
                <th>{{"NID" | translate | titlecase }}</th>
                <th>{{"PROVINCE" | translate | titlecase }}</th>
                <th>{{"SCORE" | translate | titlecase }}</th>
                <th>{{"STATUS" | translate | titlecase }}</th>

                <!-- actions -->

                <!-- <th class="border-0 font-14 px-2 text-grey">{{"PREVIEW" | translate | titlecase }}</th> -->


            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let res of candidateInquiriesData">
                <td class="cursor-pointer">{{res.id}}</td>
                <td class="cursor-pointer">{{res.fullNameEn}}</td>
                <!-- <td class="cursor-pointer">{{res.photoFilename}}</td> -->
                <td class="cursor-pointer">
                    <img src="{{photoPath+ res.photoFilename}}" onerror="this.src ='assets/images/stud-image.png';"
                        alt="Photo" class="img-fluid" width="70" id="userImageTag">
                </td>
                <!--                                <td class="cursor-pointer">{{"not provide"}}</td>-->
                <td class="cursor-pointer">{{res.nidNo}}</td>
                <td class="cursor-pointer">{{res.provinceID}}</td>
                <td class="cursor-pointer">{{res.bachlorScore}}</td>
                <td class="cursor-pointer">{{res.appstatusid}}</td>

                <!-- <td class="text-bold text-warning">
                    <button class="btn btn-sm btn-link text-warning" (click)="Preview(res?.id)"><i
                            class="fas fa-window-restore"></i>
                        {{"PREVIEW" | translate | titlecase }}</button>
                </td> -->
            </tr>
        </tbody>
    </table>
</div>